module.exports = __webpack_public_path__ + "img/player.aa6eed0a.png";